import { Events } from "./Constants";
import { TinyEmitter as EventEmitterClass } from "tiny-emitter";

export const EventEmitter = new EventEmitterClass();

export const ShowPageLoader = () => EventEmitter.emit(Events.ShowPageLoading);
export const HidePageLoader = () => EventEmitter.emit(Events.HidePageLoading);
